<template>
    <v-container grid-list-xl>
        <template v-if="loaded && orders.length > 0">
            <p class="display-1">{{ 'My Orders' | translation }}</p>

            <v-sheet v-for="order in orders" class="mb-4" :key="order.id">
                <v-toolbar class="pt-2">
                    <div class="title">{{ 'Order placed:' | translation }} {{order.success_date}}</div>
                    <v-spacer></v-spacer>
                    <div class="title">{{ 'Order number:' | translation }} {{order.id}}</div>
                </v-toolbar>

                <v-card>
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex md6>
                                <p class="title">{{ 'Billing address' | translation }}</p>
                                <v-card>
                                    <v-card-text>
                                        <div>
                                            {{getAddressField(order, 'billing', 'first_name')}}
                                            {{getAddressField(order, 'billing', 'last_name')}}
                                        </div>
                                        <div>
                                            {{getAddressField(order, 'billing', 'street')}}
                                            {{getAddressField(order, 'billing', 'house_number')}}
                                        </div>
                                        <div>
                                            {{getAddressField(order, 'billing', 'post_code')}}
                                            {{getAddressField(order, 'billing', 'city')}}
                                        </div>
                                        <div>{{getAddressField(order, 'billing', 'country')}}</div>
                                        <div>{{getAddressField(order, 'billing', 'email')}}</div>
                                    </v-card-text>
                                </v-card>
                            </v-flex>

                            <v-flex md6>
                                <p class="title">{{ 'shipping address' | translation }}</p>
                                <v-card>
                                    <v-card-text>
                                        <div>
                                            {{getAddressField(order, 'shipping', 'first_name')}}
                                            {{getAddressField(order, 'shipping', 'last_name')}}
                                        </div>
                                        <div v-if="getAddressField(order, 'shipping', 'company').length">
                                            {{getAddressField(order, 'shipping', 'company')}}
                                        </div>
                                        <div>
                                            {{getAddressField(order, 'shipping', 'street')}}
                                            {{getAddressField(order, 'shipping', 'house_number')}}
                                        </div>
                                        <div>
                                            {{getAddressField(order, 'shipping', 'post_code')}}
                                            {{getAddressField(order, 'shipping', 'city')}}
                                        </div>
                                        <div>{{getAddressField(order, 'shipping', 'country')}}</div>
                                        <div>{{getAddressField(order, 'shipping', 'email')}}</div>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-container>

                    <v-container grid-list-md white mt-3 fluid>
                        <v-sheet class="basket-items">
                            <v-sheet
                                v-for="(merchantItems, merchantId) in getMerchantizedItems(order)"
                                :key="merchantId"
                            >
                                <v-subheader
                                    v-if="Object.values(getMerchantizedItems(order)).length > 1"
                                    class="pa-0 ma-0"
                                >
                                    <a
                                        v-if="getMerchantLink(merchantItems[Object.keys(merchantItems)[0]])"
                                        class="title"
                                        :href="getMerchantLink(merchantItems[Object.keys(merchantItems)[0]])"
                                    >
                                        {{getMerchantName(merchantItems[Object.keys(merchantItems)[0]])}}
                                    </a>
                                    <p v-else class="title">
                                        {{getMerchantName(merchantItems[Object.keys(merchantItems)[0]])}}
                                    </p>
                                </v-subheader>

                                <v-container fluid grid-list-xl class="pa-0">
                                    <v-layout row wrap>
                                        <v-flex xs12 v-for="orderItem in merchantItems" :key="orderItem.id">
                                            <v-card>
                                                <v-card-text>
                                                    <v-layout row wrap>
                                                        <v-flex class="xs4 md2">
                                                            <v-img
                                                                v-if="products[orderItem.master_catalog_item_id]"
                                                                :src="products[orderItem.master_catalog_item_id].images.default.small"
                                                                :lazy-src="products[orderItem.master_catalog_item_id].images.default.placeholder"
                                                                :alt="products[orderItem.master_catalog_item_id].images.default.image_description"
                                                                :aspect-ratio="1/1"
                                                            />
                                                        </v-flex>

                                                        <v-flex class="xs8 md10">
                                                            <v-layout row wrap>
                                                                <v-flex class="xs8 md12">
                                                                    <router-link
                                                                        :to="$product.getProductRouteConfig(
                                                                            orderItem.master_catalog_item_id === orderItem.product_catalog_item_id ?
                                                                            products[orderItem.master_catalog_item_id] :
                                                                            {id: orderItem.product_catalog_item_id}
                                                                        )"
                                                                        class="subheading"
                                                                    >
                                                                        {{$basket.getItemTitle({product:
                                                                        products[orderItem.master_catalog_item_id],
                                                                        catalog_item_id:
                                                                        orderItem.master_catalog_item_id})}}
                                                                    </router-link>
                                                                </v-flex>

                                                                <v-flex xs12>
                                                                    <span>{{ 'number' | translation }} </span>
                                                                    {{orderItem.quantity}}
                                                                </v-flex>

                                                                <v-flex xs12 v-if="getBuyOptionsString(orderItem)">
                                                                    <div v-html="getBuyOptionsString(orderItem)"></div>
                                                                </v-flex>

                                                                <v-flex class="xs12 text-xs-right pb-0">
                                                                    <span>{{ 'price' | translation }} </span>
                                                                    <span
                                                                        v-if="orderItem.discount"
                                                                        class="org-preis"
                                                                    >
                                                                        {{ 'instead of' | translation }}
                                                                        <del>
                                                                            <span>
                                                                                {{orderItem.price_vat + orderItem.discount | currency}}
                                                                            </span>
                                                                        </del>
                                                                    </span>
                                                                    <span>{{orderItem.price_vat | currency}}</span>
                                                                </v-flex>

                                                                <v-flex class="xs12 text-xs-right pb-0" v-if="orderItem.discount">
                                                                    <span
                                                                        class="success--text"
                                                                    >
                                                                        {{ 'saving' | translation }}
                                                                        <span>{{orderItem.discount | currency}}</span>
                                                                    </span>
                                                                </v-flex>

                                                                <v-flex class="xs12 text-xs-right">
                                                                    <span>{{ 'total' | translation }} </span>
                                                                    <span>{{orderItem.price_total | currency}}</span>
                                                                </v-flex>
                                                                <v-flex v-if="orderItem.is_pickup" class="xs12">
                                                                    <v-checkbox
                                                                        disabled
                                                                        :input-value="true"
                                                                        hide-details
                                                                        label="Artikel selbst abholen"
                                                                        class="justify-end"
                                                                    ></v-checkbox>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>

                                        <template v-if="Object.values(getMerchantizedItems(order)).length > 1">
                                            <v-flex xs12 md6 offset-md6>
                                                <v-card v-if="getShippingPrice(order, merchantId) != undefined">
                                                    <v-card-text>
                                                        <v-layout row wrap>
                                                            <v-flex xs8>
                                                                <span>{{ 'shipping' | translation }}</span>
                                                            </v-flex>
                                                            <v-flex xs4 text-xs-right>
                                                                <span>{{getShippingPrice(order, merchantId) | currency}}</span>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>

                                            <v-flex xs12 md6 offset-md6 v-if="getDiscountPrice(order, merchantId)">
                                                <v-card>
                                                    <v-card-text>
                                                        <v-layout row wrap>
                                                            <v-flex xs8>
                                                                <span>{{ 'discount' | translation }}</span>
                                                            </v-flex>
                                                            <v-flex xs4 text-xs-right>
                                                                <span>{{getDiscountPrice(order, merchantId) | currency}}</span>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>

                                            <v-flex xs12 md6 offset-md6>
                                                <v-card>
                                                    <v-card-text>
                                                        <v-layout row wrap>
                                                            <v-flex xs8>
                                                                <span>{{ 'Subtotal' | translation }}</span>
                                                            </v-flex>
                                                            <v-flex xs4 text-xs-right>
                                                                <span>{{getMerchantTotal(order, merchantId) | currency}}</span>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-card-text>
                                                </v-card>
                                            </v-flex>
                                        </template>
                                    </v-layout>
                                </v-container>
                            </v-sheet>

                            <v-container fluid grid-list-xl class="pa-0 pt-3">
                                <v-layout row wrap>
                                    <v-flex d-flex class="xs12 md6">
                                    </v-flex>
                                    <v-flex d-flex class="xs12 md6">
                                        <v-card>
                                            <v-card-text>
                                                <v-layout row wrap align-center>
                                                    <v-flex>
                                                        <span>{{ 'Shipping to' | translation }} ({{getAddressField(order, 'shipping', 'country')}})</span>
                                                    </v-flex>
                                                    <v-flex class="text-xs-right">
                                                        {{getShippingPrice(order) | currency}}
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <product-fees :fees="$basket.getProductsFeesTotals(order.OrderItems)"></product-fees>
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>

                                    <v-flex class="xs12 md6 offset-md6">
                                        <v-card>
                                            <v-card-text>
                                                <v-container fluid pa-0>
                                                    <v-layout row wrap v-if="getDiscountPrice(order)">
                                                        <v-flex xs8>
                                                            {{ 'discount' | translation }}
                                                        </v-flex>
                                                        <v-flex xs4 text-xs-right>
                                                            - {{getDiscountPrice(order) | currency}}
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout row wrap>
                                                        <v-flex xs8>
                                                            <p class="mb-0">{{ 'Total' | translation }}</p>
                                                            <p class="caption mb-0">{{ 'incl. VAT' | translation }}</p>
                                                        </v-flex>
                                                        <v-flex xs4 text-xs-right>
                                                            {{order.price_total | currency}}
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card-text>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-sheet>
                    </v-container>
                </v-card>
            </v-sheet>
            <div class="text-xs-center" v-if="totalPages > 1">
                <v-pagination
                    v-model="page"
                    :length="totalFound"
                ></v-pagination>
            </div>
        </template>
        <v-card v-else-if="loaded">
            <v-card-title>
                {{ 'No orders ...' | translation }}
            </v-card-title>
        </v-card>
    </v-container>
</template>

<script>
    import module from './module';
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import ProductFees from '@breakmedia/prime-vue-basket/src/Basket/ProductFees';
    import {getProducts} from '@breakmedia/prime-vue-product/src/store/getProducts';
    import {Observable} from 'rxjs';
    import {first} from 'rxjs/operators';

    const moduleName = 'CustomerOrders';

    export default {
        name: moduleName,
        components: {
            ProductFees,
        },
        data() {
            return {
                loaded: false,
                orders: [],
                products: {},
                page: 1,
                limit: 10,
                totalFound: 0,
            };
        },
        created() {
            if (!(Vue.$store.state[moduleName])) {
                Vue.$store.registerModule(moduleName, module);
            }

            this.loadOrders();
        },
        computed: {
            ...mapGetters('Login', [
                'isUserLoggedIn',
            ]),
            totalPages() {
                let totalPages = 0;

                if (this.totalFound) {
                    totalPages = Math.ceil(this.totalFound / this.limit);
                }

                return totalPages;
            },
            productsIds() {
                let result = [];

                for (let order of this.orders) {
                    for (let orderItem of order.OrderItems) {
                        result.push(orderItem.master_catalog_item_id);
                    }
                }

                return result;
            },
        },
        methods: {
            ...mapActions(moduleName, {
                loadOrdersAction: 'loadOrders',
            }),
            loadOrders() {
                this.loadOrdersAction({
                    page: this.page,
                    limit: this.limit,
                }).then(orders => {
                    this.orders = orders.data;
                    this.totalFound = orders.total;
                    this.loaded = true;

                    getProducts(new Observable(
                        subscriber => subscriber.next({
                            ids: this.productsIds,
                        })
                    )).pipe(first()).subscribe(products => {
                        let indexedProducts = {};

                        if (products) {
                            for (let product of products) {
                                indexedProducts[product.id] = product;
                            }
                        }

                        this.products = indexedProducts;
                    });
                }).catch(err => {
                    err.graphQLErrors.some(error => {
                        if (error.extensions.exception.status === 403) {
                            Vue.$store.commit('Login/setAuthToken', null);
                            Vue.$store.commit('Login/setShowLoginModal', true);
                        }
                    })
                });
            },
            getMerchantizedItems(order, merchantId) {
                let merchantizedItems = {};

                for (let orderItem of order.OrderItems) {
                    for (let orderItemOptionKey of Object.keys(orderItem.Options)) {
                        if (orderItemOptionKey === 'merchant') {
                            let orderItemOptionValue = orderItem.Options[orderItemOptionKey].value;

                            if (!merchantId || orderItemOptionValue == merchantId) {
                                if (merchantizedItems[orderItemOptionValue] === undefined) {
                                    merchantizedItems[orderItemOptionValue] = [];
                                }

                                merchantizedItems[orderItemOptionValue].push(orderItem);

                                break;
                            }
                        }
                    }
                }

                return merchantizedItems;
            },
            getAddressField(order, type, field) {
                if (order.OrderAddresses && order.OrderAddresses[type]) {
                    return order.OrderAddresses[type][field] ? order.OrderAddresses[type][field] : '';
                }

                return '';
            },
            getShippingPrice(order, merchantId) {
                let result = 0;

                if (order.ShippingPrices) {
                    for (let shippingPrice of order.ShippingPrices) {
                        if (!merchantId || shippingPrice.company_department_id == merchantId) {
                            result += shippingPrice.price;
                        }
                    }
                }

                return result;
            },
            getMerchantTotal(order, merchantId) {
                let total = 0;
                let merchantizedItems = this.getMerchantizedItems(order, merchantId);

                if (merchantizedItems[merchantId]) {
                    for (let orderItem of merchantizedItems[merchantId]) {
                        total += orderItem.price_total;
                    }
                }

                return total + this.getShippingPrice(order, merchantId);
            },
            getMerchantLink(orderItem) {
                let link = '';
                let product = this.products[orderItem.master_catalog_item_id];

                if (
                    product &&
                    product.merchant[orderItem.Options.merchant.value] &&
                    product.merchant[orderItem.Options.merchant.value].data.show_shop &&
                    product.merchant[orderItem.Options.merchant.value].url
                ) {
                    link = '/haendler/' + product.merchant[orderItem.Options.merchant].url;
                }

                return link;
            },
            getMerchantName(orderItem) {
                let name = '';
                let product = this.products[orderItem.master_catalog_item_id];

                if (product && product.merchant[orderItem.Options.merchant.value]) {
                    name = product.merchant[orderItem.Options.merchant.value].data.name;
                }

                return name;
            },
            getDiscountPrice(order, merchantId) {
                let discount = 0;
                for (let fee of order.Fees) {
                    if (fee.type == 'coupon') {
                        discount += Math.abs(parseFloat(fee.value));
                    }
                }

                return discount;
            },
            getBuyOptionsString(orderItem) {
                let result = {};

                for (let option of Object.values(orderItem.Options)) {
                    if (option.BuyOptionType) {
                        let buyOptionTypeName = this.$language.translate(option.BuyOptionType.name);
                        if (!result[buyOptionTypeName]) {
                            result[buyOptionTypeName] = [];
                        }

                        if (option.value && option.value !== '0') {
                            if (option.BuyOptionType.Values) {
                                for (let buyOptionTypeValue of option.BuyOptionType.Values) {
                                    if (buyOptionTypeValue.value === option.name) {
                                        result[buyOptionTypeName].push(
                                            this.$language.translate(buyOptionTypeValue.name) + ': ' + option.value
                                        );
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }

                for (let optionType of Object.keys(result)) {
                    result[optionType] = '<span class="font-weight-bold">' + optionType + ':</span>' + ' ' +
                        result[optionType].join(', ');
                }

                return Object.values(result).join('<br>');
            },
        },
        watch: {
            page() {
                this.loadOrders();
            },
            isUserLoggedIn(value) {
                if (value) {
                    this.loadOrders();
                }
            },
        },
    };
</script>
